/// <amd-module name="DistributedTaskUI/Logs/VerticalTab/VerticalTabItem" />
import * as React from "react";

import { IVerticalTabItemProps } from "DistributedTaskUI/Logs/VerticalTab/VerticalTabItem.Types";

import { getNativeProps, divProperties } from "OfficeFabric/Utilities";

export class VerticalTabItem extends React.Component<IVerticalTabItemProps, {}> {
    public render() {
        return (
            <div
                {...getNativeProps(this.props, divProperties)}
            >
                {this.props.children}
            </div>
        );
    }
}
